
import { useEffect } from "react";

function Notify(val) {
    useEffect(() => {
        // Other functions
        window.addEventListener("storage", () => {
            // When storage changes refetch
        });
        return null
    }, []);
    return null
}
export default Notify